import { Directive } from 'vue'
import store from '@/store'

const customDirective: Directive = {
  async mounted(el, binding) {
    await store.dispatch('loadUser') // ✅ 等待用户信息获取

    applyPermission(el, binding)
  },

  updated(el, binding) {
    if (store.state.loaded) {
      applyPermission(el, binding)
    }
  }
}

function applyPermission(el: HTMLElement, binding: any) {
  const userInfo = store.state.userInfo
  const roles = store.state.roles?.[0]?.permissions?.split(',') || []

  const requiredPermissions = Array.isArray(binding.value)
    ? binding.value.map((v: any) => v.toString())
    : [binding.value?.toString()]

  const isSuper = userInfo?.info?.is_supper === 1
  const hasPermission = requiredPermissions.some((p: string) => roles.includes(p))

  el.style.display = (isSuper || hasPermission) ? '' : 'none'
}

export { customDirective }
